module.exports = __webpack_public_path__ + "img/search-by-keyword-asn.e2776037.png";